import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
import PropTypes from 'prop-types';

import {
  MenuItem,
} from '@mui/material';

const ViewAllRawMaterialGroupByLocation = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});

   let season_id = localStorage.getItem("season_id");
  useEffect(() => {
        setPermission(FindModuleById(42)); 
console.log(permission);

    axios
      .get(`/raw-materials/listing-location/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.materials);
          setData(response.data.data.materials_all);

          console.log(response.data.data.materials);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  

const editItem = (item)=>{
  window.location.href = "/raw-materials-edit/"+item;
}
// const viewItem = (item)=>{
//   window.location.href = "/raw-materials-view/"+item;
// }
const deleteItem = (item) => {
  Swal.fire({
    title: 'Do you really want to delete this record?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'DELETE'
  }).then((result) => {
    if (result.isConfirmed) {
         let season_id = localStorage.getItem("season_id");

      axios.get(`/raw-materials/delete/${season_id+'-'+item}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          })
          .then((response) => {
            console.log(response);
            if (response.data.code === 200) {
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              setTimeout(() => {
                window.location.href = "/raw-materials";
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
    }
  });
}




// ✅ Define row.original PropTypes (All expected properties)
const rowOriginalShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string, // Ensure name is validated
  lot_number: PropTypes.string.isRequired,
  date_time: PropTypes.string, // Assuming date_time is a string
  supplier_name: PropTypes.shape({
    name: PropTypes.string,
  }),
  plate_number: PropTypes.string,
  net_weight: PropTypes.number.isRequired,
  palletesation: PropTypes.arrayOf(
    PropTypes.shape({
      used: PropTypes.number.isRequired,
      type: PropTypes.number.isRequired,
      net_weight: PropTypes.number.isRequired,
    })
  ),
  createdby: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }),
  updatedby: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }),
});

// ✅ Define row PropTypes (Includes `original`)
const rowShape = PropTypes.shape({
  original: rowOriginalShape.isRequired,
});

// ✅ Cell Component for Lot Number (Details)
const DetailsCell = ({ row }) => (
  <a href={`/raw-materials-view/${row.original.id}`} className="">
    {row.original.lot_number}
  </a>
);
DetailsCell.propTypes = {
  row: rowShape.isRequired,
};

// ✅ Cell Component for Decay Net Weight
const DecayNetWeightCell = ({ row }) => {
  const total_decay = row.original.palletesation || [];
  const totalNetWeight = total_decay
    .filter(item => item.used === 1 && item.type === 1)
    .reduce((sum, item) => sum + (item.net_weight || 0), 0);
  return <span>{totalNetWeight.toFixed(2)} (KG)</span>;
};

DecayNetWeightCell.propTypes = {
  row: rowShape.isRequired,
};

// ✅ Cell Component for Decay Net Weight
const NetWeightCell = ({ row }) => {
  const total_decay = row.original.palletesation || [];
  const totalNetWeight = total_decay
    .filter(item => item.used === 1 && item.type === 2)
    .reduce((sum, item) => sum + (item.net_weight || 0), 0);
  return <span>{totalNetWeight.toFixed(2)} (KG)</span>;
};

NetWeightCell.propTypes = {
  row: rowShape.isRequired,
};

// ✅ Cell Component for Weight Difference
const WeightDifferenceCell = ({ row }) => {
  const total_decay = row.original.palletesation || [];
  const totalNetWeight = total_decay
    .filter(item => item.used === 1)
    .reduce((sum, item) => sum + (item.net_weight || 0), 0);
  const weightDifference = row.original.net_weight - totalNetWeight;

  return <span>{weightDifference.toFixed(2)} (KG)</span>;
};
WeightDifferenceCell.propTypes = {
  row: rowShape.isRequired,
};
const columns = [
  {
    header: 'Lot Number',
    accessorFn: (row) => `${row.lot_number}`,
    Cell: DetailsCell,
  },
  {
    accessorKey: 'date_time',
    header: 'Date Time',
  },
  {
    header: 'Supplier',
    accessorFn: (row) => `${row.supplier_name ? row.supplier_name.name : ''}`,
  },
  {
    accessorKey: 'plate_number',
    header: 'Plate Number',
  },
  {
    header: 'BL Net Weight',
    accessorFn: (row) => `${row.net_weight.toFixed(2)} (KG)`,
  },
  // {
  //   header: 'Net Weight',
  //   Cell: NetWeightCell,
  // },
  // {
  //     header: 'Net Weight',
  //     accessorFn: (row) => {
  //       const netWeight = row.net_weight_total ?? 0; // Default to 0 if undefined or null
  //       return `${Number(netWeight).toFixed(2)} (KG)`;
  //     },
  //   },
   {
      header: 'Decay Net Weight',
      accessorFn: (row) => {
        const netWeight = row.raw_material_decay_net_weight ?? 0; // Default to 0 if undefined or null
        return `${Number(netWeight).toFixed(2)} (KG)`;
      },
    },
  // {
  //   header: 'Decay Net Weight',
  //   Cell: DecayNetWeightCell,
  // },
   {
      header: 'Weight Difference',
      accessorFn: (row) => {
        const netWeight = row.difference ?? 0; // Default to 0 if undefined or null
        return `${Number(netWeight).toFixed(2)} (KG)`;
      },
    },
  {
      header: 'Net Weight',
      accessorFn: (row) => {
        const netWeight = row.raw_material_net_weight ?? 0; // Default to 0 if undefined or null
        return `${Number(netWeight).toFixed(2)} (KG)`;
      },
    },
    {
      accessorKey: 'boxes_in',
      header: 'Boxes IN',
    },
  {
    header: 'Created By',
    accessorFn: (row) =>
      `${row.createdby ? row.createdby.first_name + ' ' + row.createdby.last_name : ''}`,
  },
  {
    header: 'Updated By',
    accessorFn: (row) =>
      `${row.updatedby ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ''}`,
  },
];




  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Raw Material Group By Location</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/raw-materials">Raw Materials</Link>
                    </li>
                    <li className="breadcrumb-item active">
                    Raw Material Group By Location
                    </li>
                  </ul>
                </div>
              </div> 
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Raw Material Group By Location</h4>
                      <table className="table table-bordered">
                        {/* <tr>
                          <th className="p-3">Shift Date</th>
                          <td className="p-3">{value.shift_date}</td>
                        </tr> */}
                        <tr>
                          <th className="p-3">Location</th>
                          <td className="p-3">
                            {value.location ? value.location_name.title : ""}
                          </td>
                        </tr>
                      </table>
                  </div>
                </div>
              </div>
            </div>
         



            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Listing Raw Materials</h4>
                    <div className="table-responsive">
                      <MaterialReactTable columns={columns} data={data} 
                          enableColumnOrdering
                          enablePinning
                          enableRowActions
                          //renderColumnActionsMenuItems 
                          renderRowActionMenuItems={({ row }) => [
                            <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                              Edit
                            </MenuItem>,
                          <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                              Delete
                            </MenuItem>,
                          ]}
                        />
                      </div>
                  </div>
                </div>
              </div>
            </div>
         



          </div>
        </div>
      </div>
    </>
  );
};
export default ViewAllRawMaterialGroupByLocation;
